import { themeUtils as tu } from '@zen-common/components-base';

export const contentXPadding = p => {
  const smd = tu.space('smd')(p),
    mlg = tu.space('mlg')(p);
  return tu.mq({
    paddingLeft: [smd, null, mlg, smd],
    paddingRight: [smd, null, mlg, smd],
  });
};
